module.exports = __webpack_public_path__ + "eaedda045c047da4145d727798f309b7.svg";